export default __webpack_public_path__ + "static/media/EAST2480.34I-34285_-18542_0.224476ef.jpg";